import React, { memo } from 'react';
import classnames from 'classnames';
import * as call from '../../../../../../call';
import ScreenShareIcon from '../../../../../assets/icons/screenshare.svg';
import './ParticipantsGridItemAvatar.scss';
const ParticipantsGridItemAvatar = ({ name, avatar, type = call.constants.StreamType.Camera, size = 'small', }) => {
    return (<div className={classnames({
            'ml-pg-avatar': true,
            [`ml-pg-avatar--${size}`]: true,
        })}>
      <div className="ml-pg-avatar__icon">
        {type === call.constants.StreamType.Screen ? <ScreenShareIcon /> : null}
        {type === call.constants.StreamType.Camera && avatar ? (<img src={avatar} alt={name} draggable="false"/>) : null}
        {(type === call.constants.StreamType.Camera ||
            type === call.constants.StreamType.Spectator) &&
            !avatar ? (<svg>
            <use xlinkHref="#call-placeholder"></use>
          </svg>) : null}
      </div>
    </div>);
};
export default memo(ParticipantsGridItemAvatar);
